<!-- 填空题 -->
<template>
    <div class="topic_choice">
        <div class="flex topic_select">
            <!-- <div class="topic_type">{{ questionTypeName }}</div> -->
            <div class="topic_content scroll_x mar_left_10 flex-1">
                <div class="topic_title" v-html="topicInfo?.questionTitle" v-mathml></div>
                <div class="flex Flexalign mt-15" v-if="getAudioUrl(topicInfo.otherRule)">
                    <div class="mr-10">音频：</div><audio :src="getAudioUrl(topicInfo.otherRule)" controls></audio>
                </div>
                <div class="mt-10" v-if="!((testExamTime.remainingTime < 0) || isShowScoring ||
                    topicInfo.showAnalysis)">
                    <div class="mt-20">请将答案填写在下方输入框中</div>
                    <div class="answer_one mt-15" v-for="(item, index) in topicInfo.questionContext?.options"
                        :key="index">
                        <el-input v-model="item.doAnswer" style="width: 240px" :placeholder="'答案' + (index + 1)"
                            @blur="getScore(item)"
                            :disabled="(testExamTime.remainingTime <= 0) || isShowScoring || topicInfo.showAnalysis" />
                    </div>
                </div>
            </div>
        </div>
        <!-- <div v-if="!testType">
            <div class="topic_answer mt-20" v-if="isShowScoring || topicInfo.showAnalysis">
                <div class="answer_top p-20">
                    <div class="flex FlexBetween">
                        <div>答题结果</div>
                        <div>总得分：{{ getTotalStudentScore(topicInfo.questionContext?.options) }}</div>
                    </div>
                    <div class="flex FlexBetween mt-20" style="line-height: 36px;">
                        <div>
                            <div>序号：</div>
                            <div v-for="(item, index) in topicInfo.questionContext?.options" :key="index">
                                <div>{{ index + 1 }}</div>
                            </div>
                        </div>
                        <div>
                            <div>参考答案：</div>
                            <div v-for="(item, index) in topicInfo.questionContext?.options" :key="index">
                                <div>{{ item.content }}</div>
                            </div>
                        </div>
                        <div class="mar_left_20" v-if="!hideUserAnswer">
                            <div class="user_answer">你的答案：
                                <div class="bg_line"></div>
                            </div>
                            <div v-for="(item, index) in topicInfo.questionContext?.options" :key="index">
                                <div>{{ item.doAnswer || "/" }}</div>
                            </div>
                        </div>
                        <div class="mar_left_20">
                            <div>得分：</div>
                            <div class="flex Flexalign" v-for="(item, index) in topicInfo.questionContext?.options" :key="index">
                                    <el-image class="question_error_icon" :src="iconPath('question_error_icon.png')"
                                        v-if="item.isCorrect == 2"></el-image>
                                    <el-image class="question_error_icon" :src="iconPath('question_correct_icon.png')"
                                        v-if="item.isCorrect == 1"></el-image>
                                <div class="get_score ml-10" v-if="!hideUserAnswer">得分：{{ item.studentScore || 0 }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="answer_top p-20 mt-20">
                    <div class="question_analyze mar_top_10">【试题分析】</div>
                    <div class="mar_top_10" v-html="$Tools.handlerImg(topicInfo.questionAnalyze)"></div>
                    <div class="question_analyze mar_top_10">【解析】</div>
                    <div class="mar_top_10" v-html="$Tools.handlerImg(topicInfo.questionExplanation)"></div>
                </div>
            </div>
        </div> -->
        <div>
            <div class="topic_answer mt-20" v-if="isShowScoring || topicInfo.showAnalysis">
                <div class="answer_top p-20" v-if="getIsShow(1) || showAnswer">
                    <div class="flex FlexBetween">
                        <div>答题结果</div>
                        <div>总得分：{{ getTotalStudentScore(topicInfo.questionContext?.options) }}</div>
                    </div>
                    <div class="flex FlexBetween mt-20" style="line-height: 36px;">
                        <div>
                            <div>序号：</div>
                            <div v-for="(item, index) in topicInfo.questionContext?.options" :key="index">
                                <div>{{ index + 1 }}</div>
                            </div>
                        </div>
                        <div>
                            <div>参考答案：</div>
                            <div v-for="(item, index) in topicInfo.questionContext?.options" :key="index">
                                <div>{{ item.content }}</div>
                            </div>
                        </div>
                        <div class="mar_left_20" v-if="!hideUserAnswer">
                            <div class="user_answer">你的答案：
                                <div class="bg_line"></div>
                            </div>
                            <div v-for="(item, index) in topicInfo.questionContext?.options" :key="index">
                                <!-- <div>{{ item.doAnswer || "/" }}</div> -->
                                 <div :class="{'wrong-answer': item.doAnswer && item.doAnswer != item.content}">
            {{ item.doAnswer || "/" }}
        </div>
                            </div>
                        </div>
                        <div class="mar_left_20">
                            <div>得分：</div>
                            <div class="flex Flexalign" v-for="(item, index) in topicInfo.questionContext?.options" :key="index">
                                <!-- <div class="full_score"> -->
                                    <el-image class="question_error_icon" :src="iconPath('question_error_icon.png')"
                                        v-if="item.isCorrect == 2"></el-image>
                                    <el-image class="question_error_icon" :src="iconPath('question_correct_icon.png')"
                                        v-if="item.isCorrect == 1"></el-image>
                                <!-- </div> -->
                                <div class="get_score ml-10" v-if="!hideUserAnswer">得分：{{ item.studentScore || 0 }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="btn_ask">提问</div> -->
                </div>
                <div class="answer_top p-20 mt-20" v-if="getIsShow(2) || getIsShow(3) || showAnswer">
                    <div class="question_analyze mar_top_10" v-if="getIsShow(2) || showAnswer">【试题分析】</div>
                    <div class="mar_top_10" v-html="$Tools.handlerImg(topicInfo.questionAnalyze)" v-if="getIsShow(2) || showAnswer" v-mathml></div>
                    <div class="question_analyze mar_top_10" v-if="getIsShow(3) || showAnswer">【解析】</div>
                    <div class="mar_top_10" v-html="$Tools.handlerImg(topicInfo.questionExplanation)" v-if="getIsShow(3) || showAnswer" v-mathml></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import quillEditor from "@/components/quillEditor/index.vue"
import { mapState } from "vuex";
export default {
    name: "GjkcH5Choice",
    // components:{quillEditor},
    props: {
        questionInfo: {},
        isShowScoring: {
            default: false
        },
        questionTypeName: {
            default: "填空题"
        },
        testType: {},
        hideUserAnswer: {
            default: false
        },
        isChallenge: {},
        showAnswer:{}, // 用于测评报告弹题展示解析等
    },
    computed: {
        ...mapState({
            testExamTime: (state) => state.exam.testExamTime,
            testExamInfo: (state) => state.exam.testExamInfo,
        }),
    },

    data() {
        return {
            topicInfo: {},
        };
    },
    watch: {
        questionInfo: {
            handler(val) {
                if (val) {
                    this.topicInfo = this.questionInfo;
                    // 判断是否回答过
                    if (this.topicInfo.courseExamRecordId) {
                        this.topicInfo.doAnswer = this.topicInfo.questionContext.doAnswer;
                    }
                }
            },
            deep: true,
            immediate: true
        },
    },

    mounted() {
        this.setRecordTimeInterval();
    },
    beforeUnmount() {
        if (this.recordTimeInterval) {
            clearInterval(this.recordTimeInterval);
            this.recordTimeInterval = null;
        }
    },

    methods: {
        getTotalStudentScore(options) {
            let total = 0;
            options.forEach(item => {
                total += Number(item.studentScore);
            })
            return total;
        },
        setRecordTimeInterval() {
            if (!this.$Tools.empty(this.testExamInfo.otherRule)) {
                this.recordTimeInterval = setInterval(() => {
                    if (this.topicInfo.answerSection == null) {
                        this.topicInfo.answerSection = 1;
                    } else {
                        this.topicInfo.answerSection++;
                    }
                    // 按每题作答时间提交
                    if (this.testExamInfo.otherRule.timeType == 2) {
                        this.$emit("answerQuestion", this.topicInfo);
                        // 当作答时间超过设定时间，该题设置为已完成并且不给作答
                        if (
                            this.topicInfo.answerSection >=
                            this.testExamInfo.otherRule.perQuestionTime
                        ) {
                            this.topicInfo.questionContext.isFinish = true;
                            this.$emit("answerQuestion", this.topicInfo);
                            setTimeout(() => {
                                this.$emit("showAnalysis", true);
                            }, 1000)
                            if (this.recordTimeInterval) {
                                clearInterval(this.recordTimeInterval);
                                this.recordTimeInterval = null;
                            }
                        }
                    }
                    // 判断当提交后定时器关闭 
                    else if (this.isShowScoring || this.topicInfo.showAnalysis) {
                        if (this.recordTimeInterval) {
                            clearInterval(this.recordTimeInterval);
                            this.recordTimeInterval = null;
                        }
                    }
                }, 1000);
            }
        },
        getIsShow(showId) {
            let flag = false;
            if (!this.$Tools.empty(this.testExamInfo.otherRule)) {
                if (!this.$Tools.empty(this.testExamInfo.otherRule.showAnswer)) {
                    if (this.testExamInfo.otherRule.showAnswer.findIndex(item => item == showId) != -1) {
                        flag = true;
                    }
                }
            }
            return flag
        },
        getAudioUrl(info) {
            let ruleInfo = this.$Tools.jsonDecode(info);
            if (!this.$Tools.empty(ruleInfo)) {
                return ruleInfo.listeningRule?.audioUrl
            }
        },
        getScore() {
            let totalScore = 0;
            this.topicInfo.questionScore = 0;
            this.topicInfo.questionContext.isFinish = false;
            this.topicInfo.questionContext?.options.forEach(item => {
                if (item.doAnswer == item.content) {
                    this.topicInfo.questionScore += Number(item.singleScore); // 得分
                }
                totalScore += Number(item.singleScore); // 得分
                // 有答案则已完成
                if (!this.$Tools.empty(item.doAnswer)) {
                    this.topicInfo.questionContext.isFinish = true;
                }
            })
            // 判断若得分在0~最大分值之间为部分正确，0：错误，最大分值：正确
            if (this.topicInfo.questionScore == totalScore) {
                this.topicInfo.isCorrect = 1;
            } else if (this.topicInfo.questionScore == 0) {
                this.topicInfo.isCorrect = 2;
            } else {
                this.topicInfo.isCorrect = 3;
            }
            // this.topicInfo.questionContext.isFinish = !this.$Tools.empty(this.topicInfo.questionContext.doAnswer);   // 是否已完成
            this.$emit('answerQuestion', this.topicInfo);
        },
    },
};
</script>

<style lang="scss" scoped>
.topic_select {
    .topic_type {
        // margin-top: 1rem;
        min-width: 45px;
        padding: 0 8px;
        height: 21px;
        background: rgba(0, 199, 88, 0.2);
        border-radius: 4px;
        border: 1px solid #00c758;
        line-height: 21px;
        text-align: center;
        font-size: 12px;
        color: #00c758;
    }

    .topic_content {
        // overflow-x: auto;

        .topic_title {
            font-size: 16px;
            color: #242324;
            font-weight: 600;
        }
    }
}

.bottom_box {
    position: absolute;
    left: calc(50% - 60px);
    bottom: 40px;
    text-align: center;

    .btn_view {
        width: 120px;
        height: 42px;
        background: linear-gradient(90deg, #00D5C2, #00D498);
        border-radius: 21px;
        text-align: center;
        line-height: 42px;
        color: #fff;
        font-size: 18px;
    }

    .view_analysis {
        color: #13D6AA;
    }
}

.topic_answer {
    width: 100%;
    // height: 222px;
    // background: rgba(19, 214, 170, 0.05);
    border-radius: 10px;
    // padding: 20px;
    color: #666666;
    box-sizing: border-box;

    .answer_top {
        background: #F8F9FA;
        border-radius: 8px;
        width: 100%;
        box-sizing: border-box;

        .user_answer {
            position: relative;

            .bg_line {
                width: 73px;
                height: 8px;
                background: rgba(19, 214, 170, 0.2);
                position: absolute;
                bottom: 6px;
                left: 0;
            }
        }
        .wrong-answer {
    color: #ff0000;
    font-weight: bold;
}

        .question_error_icon {
            width: 26px;
            height: 26px;
        }

        .correct_value_answer {
            color: RGBA(0, 199, 88, 1);
        }

        .error_value_answer {
            color: RGBA(255, 49, 49, 1);
        }

        .btn_ask {
            width: 64px;
            height: 28px;
            background: linear-gradient(90deg, #00d5c2, #00d498);
            border-radius: 14px;
            line-height: 28px;
            text-align: center;
            color: #fff;
        }

        .get_score {
            color: #FD673B;
        }
    }

    .question_analyze {
        color: #333333;
        font-weight: 600;
    }
}
</style>